__turbopack_context__.v({
  "className": "surgena_5b6a5b0f-module__Ca9MhW__className",
  "variable": "surgena_5b6a5b0f-module__Ca9MhW__variable",
});
